import { Sparkles } from "lucide-react";
import { isToday } from "../lib/constants";

export const TonightBadge = ({ date, className = "", testid = "tonight-badge" }) => {
  if (!isToday(date)) return null;
  return (
    <span data-testid={testid}
      className={`overline inline-flex items-center gap-1.5 px-3 py-1 rounded-full badge-featured ${className}`}>
      <span className="relative flex w-2 h-2">
                <span className="relative w-2 h-2 rounded-full bg-wyd-bg" />
      </span>
      Stasera <Sparkles size={12} />
    </span>
  );
};
